import { InputAdornment } from "@mui/material";
import lockicon from "../../../../images/lockIcon.png";

export default function advBannerConfig(values) {
  console.log("values in advBannerConfig", values);
  
  const fieldConfigurations = {
    landing_page: [
      'image', 'name', 'title_color', 'text_placement_side', 'text_color', 'description'
    ],
    landing_page_mobile: [
      'image', 'name', 'text_placement_side', 'title_color', 'text_color', 'description'
    ],
    landing_rounds: [
      'image', 'name', 'text_placement_side', 'title_color', 'text_color', 'description'
    ],
    rounds_page: [
      'image', 'name', 'button_text', 'button_color', 'link', 'background_color', 'text_placement_side', 'title_color', 'btn_background_color', 'description'
    ],
    home: [
      'image', 'name', 'button_text', 'button_color', 'link', 'background_color', 'text_placement_side', 'title_color', 'btn_background_color', 'description'
    ]
  };

  // Custom field ordering for specific placements
  const customFieldOrdering = {
    landing_page: [
      'image', 'name', 'title_color',  'description', 'text_color', 'text_placement_side'
    ],
    landing_rounds: [
      'image', 'name', 'title_color',  'description', 'text_color', 'text_placement_side',
    ],
     landing_page_mobile: [
      'image', 'name', 'title_color',  'description', 'text_color', 'text_placement_side',
    ],
    // Add other placements as needed
  };

  // Custom labels for specific placements
  const customLabels = {
    landing_page: {
      description: "Adv Banner Name 2",
      text_color: "Title Color 2"
    },
    landing_rounds: {
      text_color: "Description Text Color"
    },
     landing_page_mobile: {
      description: "Adv Banner Name 2",
      text_color: "Title Color 2"
    },
    // Add more placements and their custom labels as needed
  };

  // Get the selected placement from values
  const selectedPlacement = values.selectedPlacement || values.placement;
  const allowedFields = selectedPlacement ? fieldConfigurations[selectedPlacement] : [];
  console.log("allowedFields", allowedFields);

  // Helper function to check if a field should be shown
  const shouldShowField = (fieldName) => {
    // Always show advid and placement fields
    if (fieldName === 'advid' || fieldName === 'placement') return true;
    
    // If no placement is selected, don't show other fields
    if (!selectedPlacement) return false;
    
    // Show field if it's in the allowed fields for the selected placement
    return allowedFields.includes(fieldName);
  };

  // Helper function to get custom label or default label
  const getFieldLabel = (fieldName, defaultLabel) => {
    if (selectedPlacement && customLabels[selectedPlacement] && customLabels[selectedPlacement][fieldName]) {
      return customLabels[selectedPlacement][fieldName];
    }
    return defaultLabel;
  };

  // Define exact image size requirements for each placement
  const imageSizeRestrictions = {
    landing_page_mobile: { width: 375, height: 812, exactMatch: true },
    landing_page: { width: 1440, height: 580, exactMatch: true },
    landing_rounds: { width: 1440, height: 580, exactMatch: true },
    rounds_page: { width: 1240, height: 230, exactMatch: true },
    home: { minWidth: 1, maxWidth: 1240, height: 230, exactMatch: false }, // Flexible width, exact height
  };

  // Custom image validation function
  const validateImageSize = (file, placement) => {
    return new Promise((resolve, reject) => {
      console.log('validateImageSize called with:', { file, placement });
      
      if (!file || !placement) {
        console.log('No file or placement, resolving true');
        resolve(true);
        return;
      }

      const restrictions = imageSizeRestrictions[placement];
      console.log('Restrictions for placement:', placement, restrictions);
      
      if (!restrictions) {
        console.log('No restrictions found, resolving true');
        resolve(true);
        return;
      }

      const img = new Image();
      img.onload = function() {
        const { width, height } = this;
        console.log('Image dimensions:', { width, height, placement });

        if (placement === 'home') {
          // For home placement: flexible width (up to 1200px), exact height (370px)
          console.log('Home placement validation:', {
            width,
            height,
            maxWidth: restrictions.maxWidth,
            requiredHeight: restrictions.height,
            widthValid: width <= restrictions.maxWidth,
            heightValid: height === restrictions.height
          });
          
          if (width > restrictions.maxWidth) {
            console.log('Width validation failed');
            reject(`Image width must be ${restrictions.maxWidth}px or less. Current width: ${width}px`);
          } else if (height !== restrictions.height) {
            console.log('Height validation failed');
            reject(`Image height must be exactly ${restrictions.height}px. Current height: ${height}px`);
          } else {
            console.log('Home placement validation passed');
            resolve(true);
          }
        } else {
          // For other placements: exact width and height match
          const { width: requiredWidth, height: requiredHeight } = restrictions;
          console.log('Other placement validation:', {
            width,
            height,
            requiredWidth,
            requiredHeight,
            widthValid: width === requiredWidth,
            heightValid: height === requiredHeight
          });
          
          if (width !== requiredWidth || height !== requiredHeight) {
            console.log('Exact size validation failed');
            reject(`Image size must be exactly ${requiredWidth}x${requiredHeight}px. Current size: ${width}x${height}px`);
          } else {
            console.log('Exact size validation passed');
            resolve(true);
          }
        }
      };

      img.onerror = function() {
        console.log('Image load error');
        reject('Invalid image file');
      };

      // Create URL for the image
      if (file instanceof File) {
        img.src = URL.createObjectURL(file);
      } else {
        console.log('Invalid file type');
        reject('Invalid file type');
      }
    });
  };

  // Helper function to get helper text for image requirements
  const getImageHelperText = (placement) => {
    if (!placement) return "Please select a placement first";
    
    const restrictions = imageSizeRestrictions[placement];
    if (!restrictions) return "";
    
    if (placement === 'home') {
      return `Width: up to ${restrictions.maxWidth}px, Height: exactly ${restrictions.height}px`;
    } else {
      return `Required size: ${restrictions.width}x${restrictions.height}px`;
    }
  };

  // Create all field definitions with dynamic labels
  const getAllFields = () => {
    return {
      advid: {
        shape: "input",
        type: "text",
        name: "advid",
        className: "border",
        title: "Adv Id",
        label: "Adv Id",
        placeholder: "ID",
        width: "100%",
        isDisabled: true,
        inputAdornments: {
          end: <InputAdornment position="end"> <img src={lockicon} alt='lockicon'/></InputAdornment>,
        }
      },
      image: {
        shape: "input",
        type: "file",
        name: "image",
        uploadType: 'inlineDocument',
        mode: 'view',
        handleChange: "",
        className: "border",
        title: "image",
        label: "Banner Image",
        placeholder: "Banner Image",
        width: "100% !important",
        accept: 'image/*',
        fileRestrictions: getImageHelperText(selectedPlacement),
        validation: {
          required: true,
          // Custom validation for image size
          customValidation: async (file) => {
            console.log('customValidation called with:', { file, selectedPlacement });
            
            if (!file) {
              console.log('No file provided, validation passed');
              return true;
            }
            
            // Use the current selected placement or fallback to values.placement
            const currentPlacement = selectedPlacement || values.placement;
            console.log('Using placement for validation:', currentPlacement);
            
            try {
              await validateImageSize(file, currentPlacement);
              console.log('Validation successful');
              return true;
            } catch (error) {
              console.log('Validation failed with error:', error);
              return error; // Return error message
            }
          }
        },
        // Add helper text showing required dimensions
        helperText: getImageHelperText(selectedPlacement),
      },
      placement: {
        shape: "input",
        type: "transSelect",
        name: "placement",
        className: "border",
        title: "Location",
        label: "Location",
        options: values.placements,
        placeholder: "Select Adv Banner Location",
        width: "100%",
        validation: {
          required: true,
        },
      },
      name: {
        shape: "input",
        type: "text",
        name: "name",
        className: "border",
        title: getFieldLabel("name", "Adv Banner Name"),
        label: getFieldLabel("name", "Adv Banner Name"),
        placeholder: "Enter adv banner name",
        width: "100%",
      },
      background_color: {
        shape: "input",
        type: "text",
        name: "background_color",
        className: "border",
        title: getFieldLabel("background_color", "Background Color"),
        label: getFieldLabel("background_color", "Background Color"),
        placeholder: "Enter team background color",
        width: "100%",
      },
      text_placement_side: {
        shape: "input",
        type: "select",
        name: "text_placement_side",
        className: "border",
        title: getFieldLabel("text_placement_side", "Select Text Alignment"),
        label: getFieldLabel("text_placement_side", "Select Text Alignment"),
        options: values.textAlignment,
        placeholder: "Select Text Alignment",
        width: "100%",
      },
      text_color: {
        shape: "input",
        type: "text",
        name: "text_color",
        className: "border",
        title: getFieldLabel("text_color", "Text Color"),
        label: getFieldLabel("text_color", "Text Color"),
        placeholder: "Enter Text Color",
        width: "100%",
      },
      title_color: {
        shape: "input",
        type: "text",
        name: "title_color",
        className: "border",
        title: getFieldLabel("title_color", "Title Color"),
        label: getFieldLabel("title_color", "Title Color"),
        placeholder: "Enter Title Color",
        width: "100%",
      },
      button_text: {
        shape: "input",
        type: "text",
        name: "button_text",
        className: "border",
        title: getFieldLabel("button_text", "Button Label"),
        label: getFieldLabel("button_text", "Button Label"),
        placeholder: "Enter Button Label",
        width: "100%",
      },
      button_color: {
        shape: "input",
        type: "text",
        name: "button_color",
        className: "border",
        title: getFieldLabel("button_color", "Button Text Color"),
        label: getFieldLabel("button_color", "Button Text Color"),
        placeholder: "Enter Button Text Color",
        width: "100%",
      },
      btn_background_color: {
        shape: "input",
        type: "text",
        name: "btn_background_color",
        className: "border",
        title: getFieldLabel("btn_background_color", "Button Background Color"),
        label: getFieldLabel("btn_background_color", "Button Background Color"),
        placeholder: "Enter Button Background Color",
        width: "100%",
      },
      link: {
        shape: "input",
        type: "text",
        name: "link",
        className: "border",
        title: getFieldLabel("link", "Button Link"),
        label: getFieldLabel("link", "Button Link"),
        placeholder: "Enter Button Link",
        width: "100%",
      },
      description: {
        shape: "input",
        type: "text",
        name: "description",
        className: "border",
        title: getFieldLabel("description", "Description"),
        label: getFieldLabel("description", "Description"),
        placeholder: "Enter description",
        width: "100%",
      }
    };
  };

  // Build the form structure dynamically
  const formStructure = [];
  const allFields = getAllFields();

  // First row - Always show advid and placement
  const firstRowChildren = [];
  if (shouldShowField('advid')) {
    firstRowChildren.push(allFields.advid);
  }
  if (shouldShowField('placement')) {
    firstRowChildren.push(allFields.placement);
  }
  
  if (firstRowChildren.length > 0) {
    formStructure.push({
      shape: "div",
      type: "wrapper",
      className: "",
      sx: {
        display: "grid",
        gridTemplateColumns: `repeat(${firstRowChildren.length}, 1fr)`,
        gridColumnGap: "100px",
      },
      children: firstRowChildren,
    });
  }

  // Use custom ordering if available, otherwise use default
  const fieldOrder = customFieldOrdering[selectedPlacement] || allowedFields;
  
  // Process fields in the specified order
  const orderedFields = [];
  fieldOrder.forEach(fieldName => {
    if (shouldShowField(fieldName) && allFields[fieldName]) {
      orderedFields.push({
        name: fieldName,
        config: allFields[fieldName]
      });
    }
  });

  // Group fields into rows (2 fields per row, except for image and description)
  const rows = [];
  let currentRow = [];
  
  orderedFields.forEach(field => {
    // Image and description should be in their own rows
    if (field.name === 'image') {
      // If there's a pending row, add it first
      if (currentRow.length > 0) {
        rows.push([...currentRow]);
        currentRow = [];
      }
      // Add the single field as its own row
      rows.push([field]);
    } else {
      currentRow.push(field);
      // If row is full (2 fields), add it to rows
      if (currentRow.length === 2) {
        rows.push([...currentRow]);
        currentRow = [];
      }
    }
  });
  
  // Add any remaining fields in the last row
  if (currentRow.length > 0) {
    rows.push(currentRow);
  }

  // Build form structure from rows
  rows.forEach(row => {
    const rowChildren = row.map(field => field.config);
    
    formStructure.push({
      shape: "div",
      type: "wrapper",
      className: "",
      sx: {
        display: "grid",
        gridTemplateColumns: `repeat(${rowChildren.length}, 1fr)`,
        gridColumnGap: "100px",
        mt: 6,
      },
      children: rowChildren,
    });
  });

  // Always add buttons
  formStructure.push({
    shape: "div",
    type: "wrapper",
    className: "",
    sx: { display: "flex", justifyContents: "flex-start", mt: 6 },
    children: [
      {
        shape: "button",
        type: "action",
        title: values.mode === "edit" ? "Update" : "Save",
        submitButton: false,
        name: "Save",
        sx: {
          mr: 2,
          backgroundColor: '#3C50E0',
          px: 4,
          borderRadius: 1,
          border: '1px solid #3C50E0',
          '&:hover': {
            backgroundColor: '#3C50E0',
            border: '1px solid #3C50E0'
          },
        },
        validation: {
          hiddenRules: [
            {
              mode: "view",
            },
          ],
        },
      },
      {
        shape: "button",
        type: "button",
        title: 'Launch',
        submitButton: true,
        name: "Launch",
        sx: {
          mr: 2,
          backgroundColor: '#3C50E0',
          px: 4,
          borderRadius: 1,
          border: '1px solid #3C50E0',
          '&:hover': {
            backgroundColor: '#3C50E0',
            border: '1px solid #3C50E0'
          },
        },
        validation: {
          hiddenRules: [
            {
              mode: "view",
            },
          ],
        },
      },
      {
        shape: "button",
        type: "cancel",
        title: "Cancel",
        name: "cancel",
        sx: {
          mr: 2,
          color: '#000',
          px: 4,
          borderRadius: 1,
          backgroundColor: '#fff',
          border: '1px solid #E2E8F0',
          '&:hover': {
            backgroundColor: '#fff',
            border: '1px solid #E2E8F0'
          },
        },
      },
    ],
  });

  return formStructure;
}